import {createAction, props} from '@ngrx/store';
import {UUID} from '../../../shared/types/uuid.type';
import {Destination} from '../../../services/api/destinations/destination.model';

export const stopDestination = createAction(
  '[StopDestination] Load Stop Destination',
  props<{ id: UUID }>()
);

export const stopDestinationSuccess = createAction(
  '[StopDestination] Load Stop Destination Success',
  props<{ data: Destination }>()
);

export const stopDestinationFailure = createAction(
  '[StopDestination] Load Stop Destination Failure',
  props<{ error: any }>()
);

export const clearStopDestinationState = createAction(
  '[StopDestination] clear Stop Destination State'
);
